/**
 * 가격(소요시간/금액) 변경 모달 (BS self-contained)
 *
 * 호출:
 *   $j.Ui.BS.open({
 *       target: '$j.F.Baljoo.ModalPrice',
 *       fixedHeight: true,
 *       data: {
 *           ...orderInfo,
 *           sky_role: 'bal' | 'soo' | 'adm',   // 저단가 확인창을 누구에게 하는 말로 쓸지 (기본 'bal')
 *           onApply: (data) => { ... }
 *       }
 *   });
 */
import Util from '../../../Common/Util';

export default class PriceModal {
    /**
     * 작업시간 단위가 '톤'(이삿짐/가구·가전)일 때 고르는 짐 톤수.
     * 사다리 **차량** 톤수(1/1.4/2.5/3.5/4.5/5T — g5_car_master)와는 다른 축이다.
     * 예전에는 $j.F.Car.range.ladder3 에 있었는데, 기종표 옆에 두니 차량톤수로 읽혔다.
     */
    static LOAD_TONS = [1, 2, 5, 6, 7.5, 10, 12.5, 15, 17.5, 20];

    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    init() {
        this.parent?.setTitle?.('가격변경');

        // skeleton 동기 렌더링
        const wrapId = 'window-price';
        $('#' + this.id).html(`<div id="${wrapId}">${this.skeletonHtml()}</div>`);
        this.id = wrapId;

        if (this.data['car_price'] > 0) {
            this.drawPrice();// 최초에는 가격계산없이 로딩된 가격 표시
        } else {
            this.calc();
        }
        this.draw();
        this.initHandler();
    }

    skeletonHtml() {
        const hl = (n) => $j.F.Car.hourLabel(n, this.data['car_type']);   // 지게차는 분 (일 320분 · 반나절 160분)
        return `
<h2 class="modal_title">
장비사용시간 / 금액 변경
<a href="javascript:$j.F.Baljoo.ModalChangePriceIntro.open();"><img src="/img/sign/sign_question.png" alt="?"></a>
</h2>
<div class="flex_column modal_content">
    <div class="wrap_title_wrap">
        <h3 class="wrap_title">시간유형</h3>
    </div>
    <div class="wrap flex">
        <div class="time_type_select flex_column">
            <div class="flex fz_11 hour_type" data-value="월">월대</div>
            <div class="flex fz_11 fw_medium hour_type" data-value="일">일<span class="fz_11 fw_medium">(${hl(8)})</span></div>
            <div class="flex fz_11 fw_medium hour_type" data-value="오전">반나절<span class="fz_11 fw_medium">(${hl(4)})</span></div>
            <div class="flex fz_11 fw_medium hour_type" data-value="시간">시간</div>
            <div class="flex fz_11 fw_medium hour_type" data-value="야간">야간</div>
            <div class="flex fz_11 fw_medium hour_type" data-value="톤">이삿짐</div>
            <div class="flex fz_11 fw_medium hour_type" data-value="회차">회차</div>
        </div>
        <div class="cacluate_info flex_column">
            <div>
                <h3 class="cacluate_title">상세사용시간</h3>
                <div class="detail_time_wrap flex">
                    <div class="detail_time flex" id="sel_workhour">
                        <div class="fw_bold">1달</div>
                        <div class="bracket_bottom"><img src="/img/sign/sign_bracket.png" alt="bracket"></div>
                    </div>
                    <ul class="detail_time_content" id="detail_time_content" style="padding:0px"></ul>
                    <input class="detail_time_price flex fw_bold" id="modal_base_price" value="" data-amount-kor>
                </div>
            </div>
            <div>
                <h3 class="cacluate_title">추가시간</h3>
                <div class="add_time_wrap flex">
                    <div class="add_time flex" id="sel_addhour">
                        <div class="fw_bold"><span class="morning_title fw_bold">주간</span> 1시간</div>
                        <div class="bracket_bottom"><img src="/img/sign/sign_bracket.png" alt="bracket"></div>
                    </div>
                    <ul class="add_time_content" id="add_time_content" style="padding:0px">
                        <li class="morning_night_wrap flex" id="sel_day_night">
                            <span class="" id="modal_price_add_day">주간</span>
                            <span class="" id="modal_price_add_night">야간</span>
                        </li>
                    </ul>
                    <input class="add_time_price flex fw_bold" id="modal_add_price" value="" data-amount-kor>
                </div>
            </div>
        </div>
    </div>
    <div class="total flex">
        <div class="total_title c_blue fz_16 fw_bolder">총 금액</div>
        <div class="total_price c_red fz_16 fw_bolder" id="modal_car_price"></div>
    </div>
    <div class="sky-low-note" id="modal_sky_low" style="display:none"></div>
</div>

<div class="modal_button flex apply-btn">
    <button class="button_yellow">확인</button>
</div>`;
    }

    destroy() {
        $('#' + this.id).off();
    }
    /**
     * 이벤트 핸들러등록
     * off -> on 하는 이유는 윈도우여러번 닫았다 띄웠다 하면 핸들러가 중첩될수있기때문에 기존핸들러를 제거하기위함이다.
     */
    initHandler = function(){
        const self = this;
        // 아무데나 클릭하면 열려있던 팝업 닫히게
        $('#'+this.id).off().on('click',function(){
            self.closePopup();
        });

        // 시간 유형 선택 (월,일,시간...)
        $('.hour_type').off().on('click',function(e){
            if( $(this).hasClass('on') ) return;// 이미 선택되었다면 스킵하자.
            self.closePopup();
            const type = $(this).attr('data-value');
            // 기본시간 초기화
            if( type=='회차'){
                self.data['is_return_job']=1;
            }else{
                self.data['is_return_job']=0;
                self.data['car_workdaytype']=type;
                self.data['car_workhour']=1;
            }
            // 추가시간 초기화
            self.data['add_hour']=0;
            self.data['add_hour_type']='';

            self.calc();
            self.draw();
        });

        // 상세사용시간 팝업 띄우기
        $('#sel_workhour').off().on('click',function(e){
            e.stopPropagation();
            if( $(this).hasClass('on') ) {//드로다운이 펼쳐져있으면
                $(this).removeClass('on');
            }else{//드롭다운이 안펼쳐져있으면
                self.closePopup();
                self.setBaseHourList();
            }
        });

        // 기본시간 선택
        $('#detail_time_content').off().on('click', 'li', function(e) { //<ul> 요소에 이벤트 위임 설정
            e.stopPropagation();
            // 클릭된 <li> 요소에 대한 처리 — 값은 글자가 아니라 data-value 에서 읽는다.
            // 지게차는 글자가 분('80분')이라 글자에서 숫자를 뽑으면 80시간으로 저장된다.
            const val = String($(this).attr('data-value'));
            if (['오전', '오후'].includes(val)) {
                self.data['car_workhour'] = 4;
                self.data['car_workdaytype'] = val;
            } else {
                // parseNumber 는 정수로 자른다 — 7.5톤이 7톤이 된다
                // 일수를 바꿔도 추가시간에서 고른 반나절은 남는다 (1.5일 → 2.5일)
                self.data['car_workhour'] = (parseFloat(val) || 0) + (self.hasHalf() ? 0.5 : 0);
            }
            self.closePopup();
            self.calc();
            self.draw();
        });

        // 추가시간 팝업 띄우기
        $('#sel_addhour').off().on('click',function(e){
            e.stopPropagation();
            if( $(this).hasClass('on') ) {
                $(this).removeClass('on');
            }else{
                self.closePopup();
                if(self.data['is_return_job']!=1) {
                    $(this).addClass('on');

                    // 주간,야간 버튼 on
                    if(self.data['add_hour_type']==2) {
                        $('#modal_price_add_night').addClass('on');
                        $('#modal_price_add_day').removeClass('on');
                    }
                    else {
                        $('#modal_price_add_day').addClass('on');
                        $('#modal_price_add_night').removeClass('on');
                    }

                    self.setAddHourList();
                }
            }
        });

        // 추가시간 > 주간,야간 선택
        $('#sel_day_night').off().on('click','span',function(e){
            e.stopPropagation();
            // console.log('Clicked on:', $(this).text());
            $('#sel_day_night span').removeClass('on');
            $(this).addClass('on');
            // self.data['add_hour_type']=($(this).text()=='주간'?1:2);
            self.setAddHourList();
        });

        // 추가시간 > 주간(야간) n시간 선택
        $('#add_time_content').off().on('click', 'li', function(e) {
            e.stopPropagation();
            // console.log('Clicked on:', $(this).text());
            // let txt = $(this).text();
            let txt = $(this).attr('data-value');
            // 반나절 — 추가시간(add_hour)이 아니라 일수에 붙는다. 1일 + 반나절 = 1.5일로 저장되어
            // '1일 + 추가 4시간'(8시간 뒤 이어서 4시간)과 구분된다. 금액은 서버가 반나절 단가로 센다.
            if( txt==='반나절' ){
                self.data['car_workhour'] = Math.floor(parseFloat(self.data['car_workhour'])||1) + 0.5;
                self.data['add_hour'] = 0;
                self.data['add_hour_type'] = '';
                self.closePopup();
                self.calc();
                self.draw();
                return;
            }
            // if( !/^\d/.test(txt) ) return; // 주간,야간은 패스
            if( txt.indexOf('시간')==-1 ) return;// "주간","야간"은 패스

            let arr = txt.split(' '); // 예) 주간 2시간
            if( arr[0]=='주간') self.data['add_hour_type'] = 1;
            else self.data['add_hour_type'] = 2;
            self.data['add_hour'] = Util.parseNumber(arr[1]);//문자열에서 숫자만 추출
            if( self.hasHalf() ) self.data['car_workhour'] = Math.floor(parseFloat(self.data['car_workhour']));

            self.closePopup();
            self.calc();
            self.draw();
        });

        // 기본가격 수동입력 핸들러
        $('#modal_base_price, #modal_add_price').off().on('keyup',function(e){
            $j.Common.Form.formatNumberInput(e.target);
            self.calc2();
        });
        $('#'+this.id+' .apply-btn').off().on('click',function(){
            self.apply();
        });
    }
    drawLeft = function(){
        const data = this.data;

        //=======================
        // 시간 유형 목록 초기화
        switch (data['car_type']) {
            case '리프트':
                $('.hour_type[data-value="오전"]').hide();
                $('.hour_type[data-value="시간"]').hide();
                $('.hour_type[data-value="야간"]').hide();
                break;
        }
        if( data['car_type']!='사다리'){
            $('.hour_type[data-value="톤"]').hide();
        }

        $('.hour_type').removeClass('on');

        let kwd = data['car_workdaytype'];
        if(kwd=='오후') kwd='오전';
        else if(kwd=='가구/가전'|| kwd=='이삿짐') kwd='톤';

        if( data['is_return_job']==1){
            kwd='회차';
        }

        console.log('kwd', kwd);

        $('.hour_type[data-value="' + kwd + '"]').addClass('on');
    }
    // 기본시간(상세사용시간) 초기화
    drawBaseHour = function(){
        let html = '';
        let num= this.data['car_workhour'];
        const type= this.data['car_workdaytype'];
        const is_return_job = this.data['is_return_job'];
        switch (type) {
            case '월':
                html = `${num}달`;
                break;
            case '일':
                html = `${Math.floor(num)}일`;   // 끝의 반나절은 추가시간 칸이 말한다
                break;
            case '오전':
            case '오후':
                html = this.data['car_workdaytype'];
                break;
            case '시간':
                html = `주간 ${$j.F.Car.hourLabel(num, this.data['car_type'])}`;
                break;
            case '야간':
                html = `야간 ${$j.F.Car.hourLabel(num, this.data['car_type'])}`;
                break;
            case '톤':
                html = `${num}톤`;
                break;
            // case '회차':
            //     html = '회차';
            //     break;
        }
        if( is_return_job==1){
            html='회차';
        }

        $('#sel_workhour > div:first-child').html(html);
    }
    /**
     * 추가시간 영역을 그린다.
     */
    drawAddHour = function(){
        let dn='';
        console.log('.....', this.data['add_hour_type']);
        switch( Util.int(this.data['add_hour_type']) ){
            case 1:
                dn='주간';
                $('#sel_day_night span:contains("주간")').addClass('on');
                break;
            case 2:
                dn='야간';
                $('#sel_day_night span:contains("야간")').addClass('on');
                break;
        }
        // console.log('DNDNDNDN', dn);

        // let daynight = '';// 주간 또는 야간
        let n = this.data['add_hour'];
        let html = '';
        html = `<span class="morning_title">${dn}</span> ${$j.F.Car.hourLabel(n, this.data['car_type'])}`;
        if( n==0 ) html='없음';
        if( this.hasHalf() ) html = `반나절(${$j.F.Car.hourLabel(4, this.data['car_type'])})`;
        // let is_init=false;
        // if( txt && !isNaN(txt)) is_init=true;
        // // console.log('is_init',is_init);
        // // 추가시간을 선택시
        // if( n>=0 ) {
        //     let dn='';
        //     if( daynight ) {
        //         dn=daynight;
        //     }
        //     else{
        //         dn='주간';
        //         if( this.data['add_hour_type']==2 ){
        //             dn='야간';
        //         }
        //     }
        //
        // }
        // // 시간유형 선택시
        // else{
        //     if( this.data['is_return_job']==1 ){
        //         html='회차';
        //         $('#modal_add_price').val('0').attr('disabled',true);
        //     }
        //     else{
        //         html = `<span class="morning_title">추가</span> 0시간`;
        //         let an=this.data['add_hour'];
        //         if( an>0){
        //             let dn = this.data['add_hour_type']==1?'주간':'야간';
        //             html = `<span class="morning_title">${dn}</span> ${an}시간`;
        //         }
        //         $('#modal_add_price').attr('disabled',false);
        //     }
        // }

        $('#sel_addhour > div:first-child').html(html);
    }
    /**
     * 가격을 표시
     * @param type 0(자동계산), 1(금액을 직접고칠때)
     */
    drawPrice = function(type=0){
        let base_price = this.data['car_price'] - this.data['add_hour_price'];
        if( type!=1 ) {
            $('#modal_base_price').val(Util.formatNumber(base_price));
            $('#modal_add_price').val(Util.formatNumber(this.data['add_hour_price']));
        }
        $('#modal_car_price').html(Util.formatNumber(this.data['car_price'])+' 원');

        // 스카이 저단가 고지 (2026-09-01~). 금액을 직접 고친 직후(type=1)에도 즉시 반영된다 —
        // 하한은 마지막 calc 응답값이고, 구간이 바뀌는 소요시간을 고치면 calc 가 다시 돈다.
        //
        // 여기서는 사실만 적는다 — 결과(-6차 미지급·수수료없음)는 [적용] 직전 확인창이 말한다
        // (confirmSkyLow). 금액칸 옆에서 결과까지 늘어놓으면 고치는 손이 문장에 막힌다.
        const isLow = $j.F.Car.isSkyLowWarn(this.data);
        $('#modal_sky_low').toggle(isLow)
            .html(isLow ? `스카이 저단가 — 하한 ${Util.formatNumber(Util.int(this.data['sky_low_limit']))}원 미만입니다` : '');
    }

    /**
     * 화면을 그린다.
     */
    draw = function(){
        console.log(this.data);
        this.drawLeft();
        this.drawBaseHour();
        this.drawAddHour();
    }

    /**
     * 적용하기
     */
    apply = function(){
        const self = this;
        // 회차는 저단가를 묻지 않는다 — 금액이 회차료로 내려앉는 게 정상이고,
        // -6차·발주개수는 아예 회수된다(changePrice → rollbackOnCancel). 물을 것이 없다.
        if( this.data['is_return_job']==1){
            Util.swalert('회차는 오더 취소와 동일 하게 적용 되어\n\n수.발주자 간 협의 후 처리 하셔야 합니다.\n\n적용하시겠습니까?', function(){
                self._fireApply();
            }, ['예','아니오']);
            return;
        }
        this.confirmSkyLow(() => self._fireApply());
    }

    /**
     * 저단가로 바뀌면 적용 직전에 한 번 더 묻는다 (2026-09-01~).
     *
     * **금액이 그대로여도 물어야 한다.** 하한은 소요시간 구간이 정하므로(skyLowPriceLimit)
     * 2시간을 3시간으로 옮긴 것만으로 없던 하한이 생긴다 — 그래서 '금액을 고쳤는가'가 아니라
     * **바뀐 결과가 저단가인가**로 판정한다.
     *
     * 잃는 사람은 늘 발주자다(-6차·발주개수는 발주자에게 지급된다). 그래서 누가 고치는가에 따라
     * 말이 달라진다 — 발주자는 '내 것을 잃는다', 수주자·관리자는 '발주자 것이 끊긴다'.
     *
     * 이 모달 하나가 일지(발주자·수주자)·작업완료 세 경로를 다 지나므로 게이트도 여기 한 곳이다.
     */
    confirmSkyLow = function(next){
        if (!$j.F.Car.isSkyLowWarn(this.data)) {
            // 저단가였는데 이번 변경으로 벗어나면 그것도 알린다 — 잃었던 것이 돌아오는 일인데
            // 아무 말 없이 닫히면 해제된 줄 모른다. 판정의 출발점(sky_low_now)은 서버가 준다.
            if (Util.int(this.data['sky_low_now']) && $j.F.Car.isSkyLowWarnMember()) { this.confirmSkyLowOff(next); return; }
            next(); return;
        }

        const role = this.data['sky_role'] || 'bal';
        const mine = role === 'bal';
        $j.Ui.Dialog.open({
            tone:  'danger',
            title: '저단가로 변경됩니다',
            desc:  mine ? '이 금액으로 바꾸면' : '이 금액으로 바꾸면 발주자에게',
            emph:  '-6차 · 발주개수가 지급되지 않습니다',
            rows: [
                { k: '변경 금액', v: `${Util.formatNumber(Util.int(this.data['car_price']))}원`, tone: 'danger' },
                { k: '저단가 하한', v: `${Util.formatNumber(Util.int(this.data['sky_low_limit']))}원` },
                // 수수료도 정책이 함께 내린다 (changePrice). 발주자가 직접 고른 수수료없음은
                // 건드리지 않으므로 달라지는 오더에만 이 줄이 선다 — 서버가 판정해 내려준다.
                ...(Util.int(this.data['sky_low_fee_off']) ? [{ k: '수수료', v: '있음 → 없음' }] : []),
            ],
            // 수주자가 내린 금액은 발주자에게 푸시로 통지된다 (modify_price + PushMessageBuilder {sky_low}).
            hint:    mine ? '' : '발주자에게 알림이 전송됩니다.',
            confirm: '변경',
            cancel:  '취소',
            onConfirm: next,
        });
    }

    /**
     * 저단가 해제 — confirmSkyLow 의 반대 방향. 막는 확인이 아니라 결과를 미리 보여주는 확인이다.
     * 작업완료 뒤라면 -6차가 지금 지급되고(OrderTokenFlow::regrantOnSkyLowLifted), 그 전이면 완료 때 지급된다.
     */
    confirmSkyLowOff = function(next){
        const mine = (this.data['sky_role'] || 'bal') === 'bal';
        const done = Util.int(this.data['order_status']) >= 8;
        $j.Ui.Dialog.open({
            tone:  'success',
            title: '저단가가 해제됩니다',
            desc:  mine ? '이 금액으로 바꾸면' : '이 금액으로 바꾸면 발주자에게',
            emph:  done ? '-6차 · 발주개수가 지금 지급됩니다' : '-6차 · 발주개수가 다시 지급됩니다',
            rows: [
                { k: '변경 금액', v: `${Util.formatNumber(Util.int(this.data['car_price']))}원`, tone: 'success' },
                { k: '저단가 하한', v: `${Util.formatNumber(Util.int(this.data['sky_low_limit']))}원` },
                // 저단가가 깎았던 수수료만 되살아난다 — 서버가 판정해 내려준다
                ...(Util.int(this.data['sky_low_fee_on']) ? [{ k: '수수료', v: '없음 → 있음' }] : []),
            ],
            hint:    mine ? '' : '발주자에게 알림이 전송됩니다.',
            confirm: '변경',
            cancel:  '취소',
            onConfirm: next,
        });
    }

    _fireApply = function(){
        const cb = this.data?.onApply;
        this.parent.close();
        // sky_role 은 이 모달에 건넨 '말투' 지시라 오더값이 아니다 —
        // 호출부가 applySnapshot 으로 ORDER 에 통째로 되쓰므로 여기서 뺀다.
        delete this.data['sky_role'];
        // 저단가 상태도 바뀐 금액 기준으로 옮겨둔다 — 화면을 다시 읽지 않고 한 번 더 고치면
        // 열었을 때의 상태로 판정해 해제 확인창이 또 뜨거나, 떨어질 때 수수료 줄이 빠진다.
        const nowLow = $j.F.Car.isSkyLow(this.data);
        if (nowLow !== !!Util.int(this.data['sky_low_now'])) {
            [this.data['sky_low_fee_on'], this.data['sky_low_fee_off']] = [this.data['sky_low_fee_off'], this.data['sky_low_fee_on']];
            this.data['sky_low_now'] = nowLow ? 1 : 0;
        }
        if (typeof cb === 'function') cb(this.data);
    }

    /**
     * 가격 직접 입력
     */
    calc2 = function () {
        let p1 = Util.parseNumber($('#modal_base_price').val());
        let p2 = Util.parseNumber($('#modal_add_price').val());
        this.data['car_price']=p1+p2;
        this.data['add_hour_price']=p2;
        this.drawPrice(1);
    }
    /**
     * 장비가격 서버에 계산요청하기
     */
    calc = function (){
        const self = this;
        let sendData = {
            // 기종,옵션
            'car_type': this.data['car_type'],
            'car_range': this.data['car_range'],
            'car_option': this.data['car_option'],
            // 소속
            'sosok': this.data['order_sosok'],
            // 기본시간
            'car_workdaytype': this.data['car_workdaytype'],
            'car_workhour': this.data['car_workhour'],
            'is_retun_job': this.data['is_return_job'],
            // 추가시간
            'car_workaddtype': this.data['add_hour_type'],
            'car_workaddhor': this.data['add_hour'],
            // 작업시작시간
            // 오더 행에는 work_start_h 칸이 없다(없앤 칸 — HOUR(work_time)) → 없으면 work_time 에서 뽑는다
            'work_start_h': this.data['work_start_h'] ?? (this.data['work_time'] ? dayjs(this.data['work_time']).format('HH') : ''),
            'work_day': this.data['work_day'],
            // 오더번호
            'ordernum': this.data['num'],
            // 저단가 하한은 어플발주만 — 지정·임의 오더면 서버가 0 을 준다
            'order_type': this.data['order_type'],
        };
        $j.F.Car.calcPrice(sendData, function(out){
            self.data['car_price']=out.base_price+out.more_price;
            self.data['car_price_bonsa']=out.bonsa_price;
            self.data['add_hour_price']=out.more_price;
            // 저단가 하한은 소요시간 구간(하루/반나절/시간)마다 다르다 — 소요시간을 바꾸는 게 이
            // 모달이므로 응답마다 새로 받아둔다. 안 그러면 열었을 때의 옛 구간 하한이 그대로 남고,
            // apply 때 그 옛 값이 호출부 ORDER 로 되쓰인다.
            self.data['sky_low_limit']=out['sky_low_limit'];
            self.drawPrice();
        })
    }

    /**
     * 선택된 시간유형을 알아내자.
     */
    getHourType = function(){
        return $('div.on.hour_type').attr('data-value');
    }

    /**
     * 기본작업시간 목록을 만든다.
     */
    setBaseHourList = function(){
        // [값, 글자] — 값은 저장되는 수량(시간·일·톤), 글자는 화면 표기다.
        // 지게차의 시간·야간은 글자가 분이라 둘을 나눠 둔다 (클릭은 data-value 를 읽는다).
        let list = [];
        let i=0;
        const hl = (n) => $j.F.Car.hourLabel(n, this.data['car_type']);
        switch( this.getHourType() ){
            case '월':
                for(i=1;i<=12;i++){
                    list.push([i, `${i}달`]);
                }
                break;
            case '일':
                for(i=1;i<=30;i++){
                    list.push([i, `${i}일`]);
                }
                break;
            case '오전':
                list = [['오전','오전'], ['오후','오후']];
                break;
            case '시간':
                for(i=1;i<=12;i++){
                    list.push([i, `주간 ${hl(i)}`]);
                }
                break;
            case '야간':
                for(i=1;i<=12;i++){
                    list.push([i, `야간 ${hl(i)}`]);
                }
                break;
            case '톤':
                PriceModal.LOAD_TONS.forEach((v)=>{
                    list.push([v, `${v}톤`]);
                });
                break;
            case '회차': return; // 회차일때는 드롭다운리스트를 표시하지 않는다.
        }
        let n = parseFloat(this.data['car_workhour']) || 0;
        if( this.hasHalf() ) n = Math.floor(n);
        let type = this.data['car_workdaytype'];
        let html = '';
        list.forEach(([v, label])=>{
            let selected='';
            if( $.inArray(v,['오전','오후']) !=-1 ) {
                if(type==v) selected = 'selected';
            }else {
                if (parseFloat(v) == n) selected = 'selected';
            }
            html+=`<li class="flex ${selected}" data-value="${v}">${label}</li>`;
        });
        $('#detail_time_content').html(html);
        $('#sel_workhour').addClass('on');

        // 선택된걸 제일위에 표시되게
        if( $('#detail_time_content li.selected').index()>2 ) {
            $('#detail_time_content').scrollTop(0);
            let h = $('#detail_time_content li.selected').offset().top - $('#detail_time_content').offset().top;
            $('#detail_time_content').animate({scrollTop: h-2}, 'fast');
            // $('#detail_time_content').scrollTop(h);
        }
    }

    /**
     * 추가시간 목록을 만든다.
     */
    setAddHourList = function() {
        let html='';
        let dn = $('#modal_price_add_night').hasClass('on')?'야간':'주간';
        let n = Util.int(this.data['add_hour']);
        for(let i=0; i<=12; i++){
            let selected=''; if(i==n && !this.hasHalf()) selected='selected';
            let v = `${dn} ${i}시간`;   // 값 — 클릭 핸들러가 이 문자열을 쪼개 시간 수량을 읽는다
            let s = `${dn} ${$j.F.Car.hourLabel(i, this.data['car_type'])}`;   // 글자 — 지게차는 분
            if( i==0 ) s='없음';

            html+=`<li class="flex ${selected}" data-value="${v}">${s}</li>`;
            if( i==0 && this.canAddHalf() ){
                html+=`<li class="flex ${this.hasHalf()?'selected':''}" data-value="반나절">반나절(${$j.F.Car.hourLabel(4, this.data['car_type'])})</li>`;
            }
        }
        $('#add_time_content li:not(:first-child)').remove();
        $('#add_time_content li:first-child').after(html);

        // 선택된걸 제일위에 표시되게
        if( n>3 ) {
            $('#add_time_content').scrollTop(0);
            let h = $('#add_time_content li.selected').offset().top - $('#add_time_content').offset().top;
            $('#add_time_content').animate({scrollTop: h-2}, 'fast');
            // $('#detail_time_content').scrollTop(h);
        }
    }
    /** 추가시간에 반나절을 고를 수 있는가 — 일 단위만, 리프트는 반나절 단가가 없다 */
    canAddHalf = function(){
        return ['일','하루'].includes(this.data['car_workdaytype']) && this.data['car_type']!='리프트';
    }
    /** 지금 일수 끝에 반나절이 붙어 있는가 (1.5일) */
    hasHalf = function(){
        const h = parseFloat(this.data['car_workhour']) || 0;
        return ['일','하루'].includes(this.data['car_workdaytype']) && h !== Math.floor(h);
    }
    /**
     * 열려져있는 팝업을 닫는다.
     */
    closePopup = function(){
        $('#sel_workhour').removeClass('on');
        $('#sel_addhour').removeClass('on');
    }
}
